
import { useState, useEffect, useCallback } from 'react';

const slides = [
  {
    id: 1,
    image: "https://vitassoilac.com//storage/sliders/July2025/Vpk1p0fohG1BMzNXdHYt.jpg",
    title: "Kas ve Kemik Sağlığı Desteği",
    subtitle: "3 Organik Magnezyum Formuyla Bir Arada!",
    description:
      "Sinir ve kas sağlığını destekler. Kemik sağlığını korumaya yardımcı olur. Uyku kalitesini arttırmaya ve hafızayı güçlendirmeye yardımcı olur.",
    cta: "Ürünü İncele",
    link: "#",
    badge: "Çok Satan",
    badgeColor: "bg-amber-500",
  },
  {
    id: 2,
    image: "https://vitassoilac.com//storage/sliders/May2025/LE8UHMyQSKMERKvu3Yjy.jpg",
    title: "Alkolsüz Formülüyle Bebekler İçin",
    subtitle: "Yumuşacık Bir Koku!",
    description:
      "Doğumdan itibaren güvenle kullanılabilen, cildi tahriş etmeyen özel bebek parfümü. Antetu ile bebeğiniz mis gibi koksun.",
    cta: "Keşfet",
    link: "#",
    badge: "Yeni",
    badgeColor: "bg-teal-500",
  },
  {
    id: 3,
    image: "https://vitassoilac.com//storage/sliders/July2025/DLezrTUKhishZ7qWg89e.jpg",
    title: "Gün Boyu Enerji, Güçlü Bağışıklık",
    subtitle: "3 Farklı Organik Magnezyum Formuyla!",
    description:
      "Yüksek biyoyararlanıma sahip magnezyum formları ve temel vitaminlerle formüle edilen Vitamagne, kas fonksiyonlarını ve bağışıklık sistemini destekler.",
    cta: "Hemen İncele",
    link: "#",
    badge: "Premium",
    badgeColor: "bg-emerald-600",
  },
  {
    id: 4,
    image: "https://vitassoilac.com//storage/sliders/July2025/1WAqkWuwjiLHjLHKfQds.jpg",
    title: "Çocuklar İçin Türkiye’de İlk ve Tek!",
    subtitle: "Organik Magnezyum Damla Formunda",
    description:
      "Kemik gelişimine ve büyüme ağrılarına tam destek! Bağışıklık sistemi güçlendirmeye ve diş sağlığı gelişimine katkıda bulunur.",
    cta: "Ürünü İncele",
    link: "#",
    badge: "İlk ve Tek",
    badgeColor: "bg-rose-500",
  },
  {
    id: 5,
    image: "https://vitassoilac.com//storage/sliders/July2025/rHDykEaiGP1JN4bEGGDA.jpg",
    title: "Probiyotik İçeren Gaz Giderici",
    subtitle: "ve Uyku Damlası",
    description:
      "Gaz gidermeye destek olur. Uykuya geçişi kolaylaştırır. Probiyotik sayesinde sindirim sisteminin düzenlenmesine destek olur.",
    cta: "Keşfet",
    link: "#",
    badge: "Bebek",
    badgeColor: "bg-pink-500",
  },
  {
    id: 6,
    image: "https://vitassoilac.com//storage/sliders/July2025/QpGRNmPmqo8GzGPtjqLI.jpg",
    title: "Sitikolin + Omega 3",
    subtitle: "Damla Formunda Türkiye’de İlk!",
    description:
      "Beyin fonksiyonlarını destekler. Odaklanmaya yardımcı olur, hafızayı güçlendirmeye katkıda bulunur. Dikkat eksikliği tedavisini destekler.",
    cta: "Hemen İncele",
    link: "#",
    badge: "Yeni",
    badgeColor: "bg-cyan-500",
  },
  {
    id: 7,
    image: "https://vitassoilac.com//storage/sliders/July2025/klS5W9DjTBcuLa1usa0P.jpg",
    title: "Sağlam Kemikler, Özgür Hareketler",
    subtitle: "Kolajen Desteği ile Sizinle…",
    description:
      "Kas ve eklem ağrılarının giderilmesine destek. Kolajen + Doğal Destekler ile kemik ve eklem sağlığınızı koruyun.",
    cta: "Ürünü İncele",
    link: "#",
    badge: "Kolajen",
    badgeColor: "bg-amber-600",
  },
];

export default function PromoSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [progress, setProgress] = useState(0);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const goToSlide = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setProgress(0);
      setCurrentSlide(index);
      // Ensure transition flag is cleared even if component unmounts early
      const timer = setTimeout(() => setIsTransitioning(false), 600);
      return () => clearTimeout(timer);
    },
    [isTransitioning]
  );

  const nextSlide = useCallback(() => {
    goToSlide((currentSlide + 1) % slides.length);
  }, [currentSlide, goToSlide]);

  const prevSlide = useCallback(() => {
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  }, [currentSlide, goToSlide]);

  // Touch swipe handlers
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart === null || touchEnd === null) return;
    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;
    if (Math.abs(distance) >= minSwipeDistance) {
      distance > 0 ? nextSlide() : prevSlide();
    }
  };

  // Auto‑play with progress bar
  useEffect(() => {
    if (isPaused) return;
    const duration = 6000;
    const interval = 50;
    let elapsed = 0;

    const timer = setInterval(() => {
      elapsed += interval;
      setProgress((elapsed / duration) * 100);
      if (elapsed >= duration) {
        nextSlide();
        elapsed = 0;
        setProgress(0);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [currentSlide, isPaused, nextSlide]);

  const currentData = slides[currentSlide];

  return (
    <section
      className="relative w-full overflow-hidden bg-gray-950"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      {/* Main Slider */}
      <div
        className="relative h-[360px] sm:h-[420px] md:h-[520px] lg:h-[560px]"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Background images with Ken Burns effect */}
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className="absolute inset-0 transition-opacity duration-700 ease-in-out"
            style={{
              opacity: currentSlide === index ? 1 : 0,
              zIndex: currentSlide === index ? 1 : 0,
            }}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
              style={{
                transform: currentSlide === index ? "scale(1.05)" : "scale(1)",
                transition: "transform 8s ease-out",
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent sm:from-black/70 sm:via-black/30" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          </div>
        ))}

        {/* Slide Content */}
        <div className="absolute inset-0 z-10 flex items-center">
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 md:px-10 w-full">
            <div className="max-w-xl">
              {/* Badge */}
              <div
                className="mb-3 sm:mb-4"
                style={{
                  opacity: isTransitioning ? 0 : 1,
                  transform: isTransitioning ? "translateY(20px)" : "translateY(0)",
                  transition: "all 0.5s ease 0.1s",
                }}
              >
                <span
                  className={`inline-flex items-center gap-1.5 ${currentData.badgeColor} text-white text-[10px] sm:text-xs font-bold px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-full shadow-lg`}
                >
                  <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                  {currentData.badge}
                </span>
              </div>

              {/* Title */}
              <h2
                className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-1.5 sm:mb-2"
                style={{
                  opacity: isTransitioning ? 0 : 1,
                  transform: isTransitioning ? "translateY(30px)" : "translateY(0)",
                  transition: "all 0.6s ease 0.2s",
                }}
              >
                {currentData.title}
              </h2>

              {/* Subtitle */}
              <p
                className="text-sm sm:text-base md:text-xl lg:text-2xl text-brand-300 font-semibold mb-2 sm:mb-4"
                style={{
                  opacity: isTransitioning ? 0 : 1,
                  transform: isTransitioning ? "translateY(30px)" : "translateY(0)",
                  transition: "all 0.6s ease 0.3s",
                }}
              >
                {currentData.subtitle}
              </p>

              {/* Description */}
              <p
                className="text-xs sm:text-sm md:text-base text-gray-300 leading-relaxed mb-4 sm:mb-6 md:mb-8 max-w-md line-clamp-2 sm:line-clamp-3 md:line-clamp-none"
                style={{
                  opacity: isTransitioning ? 0 : 1,
                  transform: isTransitioning ? "translateY(30px)" : "translateY(0)",
                  transition: "all 0.6s ease 0.4s",
                }}
              >
                {currentData.description}
              </p>

              {/* CTA */}
              <div
                style={{
                  opacity: isTransitioning ? 0 : 1,
                  transform: isTransitioning ? "translateY(30px)" : "translateY(0)",
                  transition: "all 0.6s ease 0.5s",
                }}
              >
                <a
                  href={currentData.link}
                  className="inline-flex items-center gap-2 bg-brand-600 hover:bg-brand-500 text-white px-5 sm:px-7 py-2.5 sm:py-3.5 rounded-xl font-semibold text-xs sm:text-sm transition-all shadow-lg shadow-brand-900/30 hover:shadow-brand-500/30 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
                >
                  {currentData.cta}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Arrows (hidden on very small screens) */}
        <button
          onClick={prevSlide}
          className="absolute left-2 sm:left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap group hidden sm:flex"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-left-s-line text-lg sm:text-xl text-white group-hover:scale-110 transition-transform"></i>
          </div>
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-2 sm:right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 w-9 h-9 sm:w-11 sm:h-11 bg-white/10 backdrop-blur-md border border-white/20 rounded-full flex items-center justify-center hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap group hidden sm:flex"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-s-line text-lg sm:text-xl text-white group-hover:scale-110 transition-transform"></i>
          </div>
        </button>

        {/* Mobile dot indicators */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex gap-1.5 sm:hidden">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                currentSlide === index ? "w-6 bg-brand-400" : "w-1.5 bg-white/50"
              }`}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Bottom Navigation Bar – hidden on mobile, show dots instead */}
      <div className="relative z-20 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 hidden sm:block">
        <div className="max-w-[1440px] mx-auto">
          <div className="flex">
            {slides.map((slide, index) => (
              <button
                key={slide.id}
                onClick={() => goToSlide(index)}
                className={`relative flex-1 py-2.5 sm:py-3 px-1 sm:px-2 text-center transition-all duration-300 cursor-pointer group ${
                  currentSlide === index ? "bg-brand-600/20" : "hover:bg-white/5"
                }`}
              >
                {/* Progress bar for active slide */}
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-gray-700 overflow-hidden">
                  <div
                    className="h-full bg-brand-400 transition-all duration-100 ease-linear"
                    style={{
                      width: currentSlide === index ? `${progress}%` : "0%",
                    }}
                  />
                </div>
                <span
                  className={`text-[9px] sm:text-[10px] md:text-xs font-medium line-clamp-1 ${
                    currentSlide === index
                      ? "text-brand-300"
                      : "text-gray-500 group-hover:text-gray-300"
                  }`}
                >
                  {slide.title.length > 15
                    ? `${slide.title.substring(0, 15)}...`
                    : slide.title}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Mini Product Cards */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-[1440px] mx-auto px-3 sm:px-4 py-3 sm:py-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
            <MiniProductCard
              image="https://vitassoilac.com//storage/products/June2025/magtho kids.jpg"
              name="MAG-THREEON Kids"
              subtitle="Organik Magnezyum Damla"
              price="710,10 ₺"
              oldPrice="789,00 ₺"
              badge="Çok Satan"
              badgeColor="bg-amber-500"
            />
            <MiniProductCard
              image="https://vitassoilac.com//storage/products/February2026/Sitikids-1.png"
              name="Sitikids 50ml"
              subtitle="Sitikolin + Omega 3 DHA"
              price="890,10 ₺"
              oldPrice="989,00 ₺"
              badge="Yeni"
              badgeColor="bg-brand-500"
            />
            <MiniProductCard
              image="https://vitassoilac.com//storage/products/June2025/vitaoste 2.jpg"
              name="VitaOste"
              subtitle="Kemik & Eklem Desteği"
              price="1.449 ₺"
              oldPrice=""
              badge="Yeni"
              badgeColor="bg-brand-400"
              className="hidden sm:flex md:flex"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function MiniProductCard({
  image,
  name,
  subtitle,
  price,
  oldPrice,
  badge,
  badgeColor,
  className = "",
}: {
  image: string;
  name: string;
  subtitle: string;
  price: string;
  oldPrice: string;
  badge: string;
  badgeColor: string;
  className?: string;
}) {
  return (
    <a
      href="#"
      className={`group flex items-center gap-3 sm:gap-4 bg-gray-50 hover:bg-brand-50/50 rounded-xl p-2.5 sm:p-3 transition-all duration-300 hover:shadow-md cursor-pointer border border-transparent hover:border-brand-100 ${className}`}
    >
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden bg-white flex-shrink-0 border border-gray-100 group-hover:border-brand-200 transition-colors">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-contain p-1 sm:p-1.5 group-hover:scale-110 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5 sm:mb-1">
          <span className={`${badgeColor} text-white text-[8px] sm:text-[9px] font-bold px-1.5 sm:px-2 py-0.5 rounded-md`}>
            {badge}
          </span>
        </div>
        <h4 className="font-bold text-gray-900 text-xs sm:text-sm group-hover:text-brand-700 transition-colors truncate">
          {name}
        </h4>
        <p className="text-gray-500 text-[10px] sm:text-xs truncate">{subtitle}</p>
        <div className="flex items-center gap-2 mt-0.5 sm:mt-1">
          <span className="text-brand-700 font-bold text-xs sm:text-sm">{price}</span>
          {oldPrice && <span className="text-gray-400 text-[10px] sm:text-xs line-through">{oldPrice}</span>}
        </div>
      </div>
      <div className="w-7 h-7 sm:w-8 sm:h-8 bg-brand-600 rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all flex-shrink-0">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-line text-white text-xs sm:text-sm"></i>
        </div>
      </div>
    </a>
  );
}
